import { Box, Divider } from "@origin-digital/ods-core";
import { Skeleton } from "@origin-digital/ods-lab";

const SkeletonTile = ({ dataId }: { dataId: string }) => (
  <Box
    display="flex"
    width="full"
    flexDirection="row"
    alignItems="flex-start"
    gap="small"
    data-id={dataId}
  >
    <Box paddingY="xxxsmall">
      <Skeleton width={20} height={30} backgroundColor="dark" />
    </Box>
    <Box width="full">
      <Skeleton height={35} variant="text" width="50%" backgroundColor="dark" />
      <Skeleton variant="text" width="100%" backgroundColor="dark" />
    </Box>
  </Box>
);

export const PopularArticlesSkeleton = () => {
  return (
    <Box display="flex" width="full" gap="xsmall" flexDirection="column">
      <SkeletonTile dataId="popular-articles-skeleton-tile-1" />
      <Divider />
      <SkeletonTile dataId="popular-articles-skeleton-tile-2" />
      <Divider />
      <SkeletonTile dataId="popular-articles-skeleton-tile-3" />
      <Divider />
    </Box>
  );
};
